enum FreeTrialActionTypes {
	STRIPE_SUCCESS_SUBSCRIPTION = 'STRIPE_SUCCESS_SUBSCRIPTION',

	HUBSPOT_PRETRIAL = 'HUBSPOT_PRETRIAL',

	HUBSPOT_PRETRIAL_FAILURE = 'HUBSPOT_PRETRIAL_FAILURE'
}

export { FreeTrialActionTypes };
